function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
/** @jsxImportSource @emotion/react */ import "core-js/modules/web.dom-collections.iterator.js";
let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css, Global } from '@emotion/react';
import { Portal } from '../../../components/Portal';
import useFocusTrap from '../../../hooks/useFocusTrap';
import useStateRef from '../../../hooks/useStateRef';
import useKey from '../../hooks/useKey';
import useStyles from './ContentModal.style';
function ContentModal(props) {
    const { onClose, usePortal = true, disableAnimation, children } = props, rest = _object_without_properties(props, [
        "onClose",
        "usePortal",
        "disableAnimation",
        "children"
    ]);
    const styles = useStyles({
        disableAnimation
    });
    const [ref, modalElement] = useStateRef();
    useFocusTrap(modalElement, {
        active: true,
        restoreFocusOnUnmount: true
    });
    useKey('Escape', onClose);
    const WrapperComponent = usePortal ? Portal : 'div';
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Global, {
                styles: css(t || (t = _`
          body {
            overflow: hidden;
            max-height: 100vh;
          }
        `))
            }),
            /*#__PURE__*/ _jsxs(WrapperComponent, {
                css: styles.root,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        css: styles.backdrop,
                        role: "presentation",
                        onClick: onClose
                    }),
                    /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                        ref: ref,
                        css: styles.wrapper
                    }, rest), {
                        role: "dialog",
                        tabIndex: -1,
                        children: children
                    }))
                ]
            })
        ]
    });
}
export default ContentModal;
